import { useTranslation } from "react-i18next";

const comparisonData = [
  { product: "Nike Air Force 1", price: "€80", quality: "Alta", store: "Weidian", rating: 5 },
  { product: "Jordan 4 Retro", price: "€120", quality: "Alta", store: "Taobao", rating: 5 },
  { product: "Yeezy 350", price: "€110", quality: "Média", store: "1688", rating: 4 },
  { product: "New Balance 550", price: "€95", quality: "Alta", store: "Weidian", rating: 5 },
  { product: "Adidas Samba", price: "€75", quality: "Média-Alta", store: "Taobao", rating: 4 },
];

export default function ComparisonSection() {
  const { t } = useTranslation();

  return (
    <section id="comparison" className="relative w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium uppercase tracking-wider mb-4">
            Comparação
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">
            {t("sectionComparison")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            Veja como os preços se comparam entre diferentes lojas e encontre as melhores ofertas
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-background-200">
                  <th className="text-left px-4 md:px-6 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Produto</th>
                  <th className="text-left px-4 md:px-6 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Preço</th>
                  <th className="text-left px-4 md:px-6 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Qualidade</th>
                  <th className="text-left px-4 md:px-6 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Loja</th>
                  <th className="text-left px-4 md:px-6 py-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider">Recomendação</th>
                </tr>
              </thead>
              <tbody>
                {comparisonData.map((item, idx) => (
                  <tr key={idx} className="border-b border-background-200 last:border-0 hover:bg-background-100/50 transition-colors">
                    <td className="px-4 md:px-6 py-3.5 text-foreground-900 font-medium whitespace-nowrap">{item.product}</td>
                    <td className="px-4 md:px-6 py-3.5 text-foreground-700 whitespace-nowrap">{item.price}</td>
                    <td className="px-4 md:px-6 py-3.5 whitespace-nowrap">
                      <span className={`inline-block px-2 py-0.5 rounded-full text-xs font-medium ${
                        item.quality === "Alta" ? "bg-primary-100 text-primary-700" :
                        item.quality === "Média-Alta" ? "bg-accent-100 text-accent-700" :
                        "bg-secondary-100 text-secondary-700"
                      }`}>
                        {item.quality}
                      </span>
                    </td>
                    <td className="px-4 md:px-6 py-3.5 text-foreground-600 whitespace-nowrap">{item.store}</td>
                    <td className="px-4 md:px-6 py-3.5 whitespace-nowrap">
                      <span className="text-accent-500">
                        {"★".repeat(item.rating)}{"☆".repeat(5 - item.rating)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center mt-8">
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            {t("btnViewComparison")} <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}